<div class="flex flex-row p-5">
  <p>
    <iframe title="datastudio" style="min-height: 95vh;border: 0;" src="https://datastudio.google.com/embed/reporting/378e58af-de7f-424e-80ab-187556d37dd3/page/68egC" width="1500" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
  </p>
</div>